module.exports = __webpack_public_path__ + "static/media/speaker.747c1249.svg";